

<template>
  <div class="row mx-0">
    <b-card class="col-9">
      <b-row class="mt-2">
        <b-form-input 
          v-model="filtersTemp.search" 
          placeholder="Buscar por nombres, apellidos o cedula" 
          type="text"
          class="col-5" 
        />

        <flat-pickr
          v-model="filtersTemp.fechaDesde"
          placeholder="Fecha Desde:"
          class="form-control col-3 mx-1"
          :config="dateConfig"
        />

        <flat-pickr
          v-model="filtersTemp.fechaHasta"
          placeholder="Fecha Hasta:"
          class="form-control col-3"
          :config="dateConfig"
        />
        
        <b-col md="4" class="mt-1">
          <b-button 
            variant="primary" 
            @click="onSetFilters"
          >
            <span style="color: white;">
              <font-awesome-icon 
                icon="magnifying-glass" 
                style="color: white;" 
              /> 
              Buscar
            </span>
          </b-button>

          <b-button 
            class="ml-1" 
            variant="warning" 
            @click="onClearFilters"
            title="Limpiar filtros"
          >
            <i class="fa-solid fa-eraser"/>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="col-3" style="border: 1px solid #c9c9c9">
      <h5 class="mb-1">Observaciones</h5>
      <div class="row d-flex align-items-center mb-1">
        <h4 class="col mb-0">Sin cedulas: </h4>
        <span class="">{{observaciones.sinCedulas}} (total)</span>
        <b-form-checkbox
          v-model="filtersTemp.observaciones"
          :value="'sinCedulas'"
          switch 
          size="md"
          class="ml-2"
        />
      </div>
      <!-- <div class="row d-flex align-items-center">
        <h4 class="col mb-0">Sin H. Clinica: </h4>
        <span class="ml-1">{{observaciones.sinHistorias}} (total)</span>
        <b-form-checkbox
          v-model="filtersTemp.observaciones"
          :value="'sinHistorias'"
          switch 
          size="md"
          class="ml-2"
        />
      </div> -->
    </b-card>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { getEstablecimientoLS } from "@/shared/helpers";
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';

export default {
  name: 'FilterAdmisiones',
  components: {
    flatPickr
  },
  created() {
    this.loadFiltersLS();
    this.getObservaciones();
  },
  data() {
    return {
      observaciones: {
        sinCedulas: 0,
        sinHistorias: 0
      },
      filtersTemp: {
        search: null,
        fechaDesde: null,
        fechaHasta: null,
        observaciones: null
      },
      filters: null,
      dateConfig: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        allowInput: true,
        enableTime: false,
        clickOpens: true,
        static: false,
        disableMobile: true
      }
    }
  },
  methods: {
    onSetFilters() {
      this.filters = { ...this.filtersTemp };
      this.$emit('apply-filters'); // Notificar al componente padre
      this.getObservaciones(); // Actualizar las observaciones con los nuevos filtros
    },
    loadFiltersLS() {
      const dataFilters = JSON.parse(localStorage.getItem('filterAdmisiones'));
      if (dataFilters) this.filtersTemp = dataFilters;
      this.onSetFilters();
    },
    onClearFilters() {
      this.filtersTemp = {
        search: null,
        fechaDesde: null,
        fechaHasta: null,
        observaciones: null
      };
      this.onSetFilters();
    },
    
    async getObservaciones() {
      const query = `
        query Numerobservacionesadmisiones(
          $establecimiento: ID,
          $search    : String,
          $fechaDesde: String,
          $fechaHasta: String
        ) {
          numerobservacionesadmisiones(
            establecimiento: $establecimiento,
            search    : $search,
            fechaDesde: $fechaDesde,
            fechaHasta: $fechaHasta
          ) {
            status
            sinCedulas
            sinHistorias
            message
          }
        }
      `;
      const establecimiento = getEstablecimientoLS();
      const variables = {
        establecimiento: establecimiento.id,
        search    : this.filters?.search || null,
        fechaDesde: this.filters?.fechaDesde || null,
        fechaHasta: this.filters?.fechaHasta || null
      };
      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status !== 200) return;
        const response2 = response.data.data.numerobservacionesadmisiones;
        if (response2.status !== 'success') {
          console.error('Error en numerobservacionesadmisiones:', response2.message);
          return;
        }
        const data = {
          sinCedulas: response2.sinCedulas,
          sinHistorias: response2.sinHistorias
        };
        this.observaciones = data;
      } catch (error) {
        console.log(error);
      }
    }
  },


  
  watch: {
    filters: {
      deep: true,
      handler() {
        if (!this.filters) return;
        localStorage.setItem('filterAdmisiones', JSON.stringify(this.filters));
        this.$store.commit('setFilterAdmisiones', this.filters);
      }
    }
  }
}
</script>

<style>
@import '~flatpickr/dist/flatpickr.min.css';
.flatpickr-calendar {
  z-index: 9999 !important;
}
</style>